import React from 'react';
import { colors } from '../../config/styles';
import { IStyled } from '../../styles/types';
import SvgIcon from './SvgIcon';

interface IProps extends IStyled {
  size?: number;
  onClick?: (e: React.MouseEvent) => void;
  isActive?: boolean;
}

const FavoriteStarIcon = ({
  size = 16,
  onClick,
  isActive,
  className,
}: IProps) => {
  return (
    <SvgIcon
      name={isActive ? 'star-fill' : 'star'}
      width={size}
      height={size}
      onClick={onClick}
      isActive={isActive}
      isHoverable={typeof onClick === 'function'}
      activeColor={colors.favoriteGoldTitle}
      className={className}
      customFill="currentColor"
    />
  );
};

export default FavoriteStarIcon;
